var map = {
	"./1_camera.svg": "1f1c",
	"./1_camera_and_episodes.svg": "725f",
	"./2_cameras_and_episodes.svg": "cd2c",
	"./3_cameras_and_episodes.svg": "d8c2",
	"./4_cameras.svg": "f7e1",
	"./4_cameras_and_episodes.svg": "2a0b",
	"./6_cameras.svg": "0ee9",
	"./9_cameras.svg": "3fe1",
	"./add.svg": "1756",
	"./alarm-screen.svg": "b9ce",
	"./alert-delivery/ad_expand.svg": "8112",
	"./alert-delivery/ad_mail.svg": "0599",
	"./alert-delivery/ad_message.svg": "5d0e",
	"./alert-delivery/ad_screen.svg": "6101",
	"./alerts.svg": "a388",
	"./annex/annex_cancel.svg": "8647",
	"./annex/annex_done_all.svg": "c6aa",
	"./annex/annex_done_all_auto.svg": "9c00",
	"./annex/annex_failure.svg": "4098",
	"./annex/annex_in_work.svg": "012d",
	"./annex/annex_success.svg": "66fc",
	"./annex/message.svg": "c805",
	"./archive.svg": "e901",
	"./areas.svg": "4ebf",
	"./arrow-left.svg": "8c15",
	"./arrow-right.svg": "b52b",
	"./arrow_right.svg": "342b",
	"./arrows-up-down.svg": "f1c9",
	"./attach.svg": "5528",
	"./audit-log.svg": "d058",
	"./authenticate.svg": "5d894",
	"./bars.svg": "237b",
	"./bi-analitycs.svg": "fa46",
	"./block.svg": "132d",
	"./camera-group.svg": "d3dc",
	"./camera-track.svg": "13a6",
	"./camera.svg": "0b5f",
	"./cancel.svg": "f552",
	"./car.svg": "979c",
	"./car2.svg": "8a74",
	"./card-add.svg": "befd",
	"./card-view.svg": "559b",
	"./cards.svg": "0db9",
	"./cards/cards_matched.svg": "cd12",
	"./cards/cards_related.svg": "b6e3",
	"./case_alert.svg": "485a0",
	"./change-lang.svg": "78a2",
	"./check.svg": "2e13",
	"./chevron-down.svg": "937e",
	"./chevron-down__padding_none.svg": "b97d",
	"./chevron-left.svg": "5969",
	"./chevron-right.svg": "c6e2",
	"./chevron-up.svg": "1296",
	"./cibr-kycp.svg": "1bfb",
	"./cibr.svg": "c254",
	"./circle-big.svg": "cb6ec",
	"./circle.svg": "7240",
	"./close.svg": "3128",
	"./close_small.svg": "6c3b",
	"./clusters.svg": "14c8",
	"./computer.svg": "9d78",
	"./configure.svg": "85fb",
	"./connection.svg": "cb95",
	"./connections.svg": "8dcd",
	"./copy.svg": "a9c4",
	"./counters.svg": "2c05",
	"./create-report.svg": "1d6d",
	"./dark-theme.svg": "d9a8",
	"./data-sources-next.svg": "6f2a",
	"./data-sources/ds-back.svg": "7888",
	"./data-sources/ds-f.svg": "362a",
	"./data-sources/ds-mirror.svg": "c723",
	"./data-sources/ds-rotate-left.svg": "9b32",
	"./data-sources/ds-rotate-right.svg": "482a",
	"./delete.svg": "1941",
	"./devtools.svg": "c19e",
	"./done-all.svg": "f236",
	"./download.svg": "6c55",
	"./edit.svg": "d984",
	"./empty.svg": "ca36",
	"./episodes.svg": "c5ce",
	"./eraser.svg": "c58b",
	"./error-alt.svg": "904d",
	"./error.svg": "0552",
	"./events.svg": "21f3",
	"./external-search.svg": "a075",
	"./eye-closed.svg": "90fe",
	"./eye-open.svg": "2b23",
	"./face-square.svg": "426b",
	"./face.svg": "3a99",
	"./failure.svg": "3902",
	"./favorite-outline.svg": "6728",
	"./file-broken.svg": "dd74",
	"./file.svg": "0f68",
	"./filter.svg": "2fad",
	"./folder.svg": "8302",
	"./fullscreen-exit.svg": "af83",
	"./fullscreen.svg": "5a23",
	"./id.svg": "b2d9",
	"./info.svg": "b488",
	"./items.svg": "efe0",
	"./left-panel.svg": "8803",
	"./light-theme.svg": "d00c",
	"./lines.svg": "ca59",
	"./link-circle.svg": "4a2c",
	"./location-nav.svg": "bff2",
	"./location.svg": "e346",
	"./logout.svg": "c5de",
	"./main-picture.svg": "6f03",
	"./map-select.svg": "07f5",
	"./map-view.svg": "9f69",
	"./minus.svg": "cc9c",
	"./more-vertical.svg": "4c2d",
	"./more.svg": "4140",
	"./mute.svg": "5a74",
	"./navigation-double-left.svg": "0215",
	"./navigation-double-right.svg": "0e1c",
	"./navigation-left.svg": "287f",
	"./navigation-refresh.svg": "329b",
	"./navigation-right.svg": "4a7c",
	"./open_folder.svg": "ded1",
	"./participant-add.svg": "50bd",
	"./participant-create.svg": "4b79",
	"./person.svg": "dd34",
	"./photo.svg": "8aba",
	"./picture.svg": "f864",
	"./pin.svg": "673a",
	"./play-outline.svg": "51b3",
	"./play-processing.svg": "99ad",
	"./play.svg": "0e96",
	"./player/backward-15.svg": "56df",
	"./player/backward-60.svg": "fd2e",
	"./player/detect-auto.svg": "886f",
	"./player/detect-body.svg": "b9b0",
	"./player/detect-face.svg": "7fbf",
	"./player/forward-15.svg": "2a58",
	"./player/forward-60.svg": "2e34",
	"./player/live-mode.svg": "cb0e",
	"./player/pause.svg": "d8bb",
	"./player/play.svg": "7b79",
	"./player/scroll-left.svg": "659e",
	"./player/scroll-right.svg": "a176",
	"./player/vp-close-panel.svg": "d618",
	"./player/vp-dialog-close.svg": "54df",
	"./player/vp-info.svg": "6b49",
	"./player/vp-ptz.svg": "f2c1",
	"./player/vp-settings.svg": "f535",
	"./player/vp_backward_15.svg": "cdaf",
	"./player/vp_backward_60.svg": "8aec",
	"./player/vp_camera_next.svg": "0374",
	"./player/vp_camera_prev.svg": "7c76",
	"./player/vp_download.svg": "966b",
	"./player/vp_event_next.svg": "b765",
	"./player/vp_event_prev.svg": "9e14",
	"./player/vp_forward_15.svg": "af27",
	"./player/vp_forward_60.svg": "48cd",
	"./player/vp_fullscreen_enter.svg": "673c",
	"./player/vp_fullscreen_off.svg": "df78",
	"./player/vp_live.svg": "de0c",
	"./player/vp_pause.svg": "9a4b",
	"./player/vp_photo.svg": "f917",
	"./player/vp_play.svg": "a395",
	"./player/zoom-in.svg": "74b8",
	"./player/zoom-out.svg": "255d",
	"./player/zoom_minus.svg": "dc8b",
	"./player/zoom_plus.svg": "be43",
	"./preferences.svg": "d92c",
	"./process.svg": "bd41",
	"./refresh.svg": "2358",
	"./relations.svg": "c075",
	"./revert.svg": "5f82",
	"./right-column.svg": "1b65",
	"./ring-unmute.svg": "8363",
	"./ring.svg": "8b06",
	"./roles.svg": "e7fe",
	"./rotate-left.svg": "645f",
	"./rotate-right.svg": "2b4d",
	"./row-view.svg": "2dbf",
	"./scroll-up.svg": "a3d8",
	"./search-alt.svg": "dacd",
	"./search-wrapped.svg": "5160",
	"./search.svg": "50ac",
	"./select-all.svg": "7f60",
	"./select.svg": "2199",
	"./select_checkbox.svg": "a3d5",
	"./show-events.svg": "3cf0",
	"./show-track.svg": "3dbc",
	"./smartphone.svg": "6b77",
	"./star.svg": "baf0",
	"./statistics.svg": "35ea",
	"./stop-processing.svg": "87c7",
	"./stop.svg": "ebfd",
	"./success.svg": "4e49",
	"./table-actions/table-action-edit.svg": "b208",
	"./table-actions/table-action-refresh.svg": "e30c",
	"./table-actions/table-action-trash.svg": "1257",
	"./target.svg": "7cba",
	"./tracks.svg": "5838",
	"./trash.svg": "741a",
	"./unknown.svg": "4656",
	"./unmute.svg": "9c3e",
	"./upload.svg": "ebd0",
	"./user.svg": "b051",
	"./users.svg": "35bb",
	"./vector.svg": "da0e",
	"./video-wall.svg": "ed7c",
	"./videos.svg": "efe8",
	"./view-outline.svg": "8c3b",
	"./vms.svg": "3187",
	"./warning.svg": "52a7",
	"./webhook.svg": "d4c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b083";